import { FC, useMemo } from "react";
import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis } from "recharts";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { SKUAnalytics, TagAnalytics } from "@/data/types";
import { formatByPeriod } from "@/lib/utils";

const chartConfig = {
  views: {
    label: "Page Views",
  },
  programed: {
    label: "Programmed",
  },
  api: {
    label: "API",
  },
  custom: {
    label: "Custom",
  },
} satisfies ChartConfig;

type Props = {
  data?: SKUAnalytics | TagAnalytics;
};

export const TagInteractionCharts: FC<Props> = ({ data }) => {
  const chartData = useMemo(() => {
    if (!data) {
      return [];
    }

    return Object.keys(data.tag_view_verifications_data).map((time) => {
      console.log();
      return {
        time,
        views: data.tag_view_verifications_data[time],
        programed: data.tag_program_verifications_data[time],
        api: data.external_tag_verifications_data[time],
        custom: data.tag_custom_verifications_data[time],
      };
    });
  }, [data]);

  return (
    <Card className="flex-1">
      <CardHeader>
        <CardTitle>Verifications</CardTitle>
        <CardDescription>
          Types of tag verifications made over time
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[240px] w-full">
          <LineChart accessibilityLayer data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="time"
              tickLine={false}
              axisLine={false}
              tickMargin={10}
              tickFormatter={(value) => formatByPeriod(value, data?.period)}
            />
            <YAxis axisLine={false} tickLine={false} />
            <ChartTooltip
              cursor={false}
              content={
                <ChartTooltipContent
                  labelFormatter={(value) =>
                    formatByPeriod(value, data?.period)
                  }
                />
              }
            />

            <Line
              name="Page Views"
              dataKey="views"
              type="monotone"
              stroke="var(--color-blue-600)"
              strokeWidth={2}
              dot={false}
              isAnimationActive={false}
            />
            <Line
              name="Programmed"
              dataKey="programed"
              type="monotone"
              stroke="var(--color-purple-500)"
              strokeWidth={2}
              dot={false}
              isAnimationActive={false}
            />
            <Line
              name="API"
              dataKey="api"
              type="monotone"
              stroke="var(--color-pink-500)"
              strokeWidth={2}
              dot={false}
              isAnimationActive={false}
            />
            <Line
              name="Custom"
              dataKey="custom"
              type="monotone"
              stroke="var(--color-green-500)"
              strokeWidth={2}
              dot={false}
              isAnimationActive={false}
            />
            <Legend iconSize={8} iconType="square" verticalAlign="bottom" />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
